type ChangePageUrl = (url: string, transformation: (page: number) => number) => string;

type GetPageUrl = (url: string) => string;

const changePageUrl: ChangePageUrl = (url, transformation) => {
  const newUrl = new URL(url);
  const pageParam = newUrl.searchParams.get("page");
  const currentPage = parseInt(pageParam || "1", 10);
  newUrl.searchParams.set("page", transformation(currentPage).toString());
  return newUrl.toString();
};

export const getPrevPageUrl: GetPageUrl = url => changePageUrl(url, page => page - 1);

export const getNextPageUrl: GetPageUrl = url => changePageUrl(url, page => page + 1);

export const removePageFromUrl: GetPageUrl = url => {
  const newUrl = new URL(url);
  newUrl.searchParams.delete("page");
  return newUrl.toString();
};
